import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import Footer from 'components/InCall/CallFooter';
import actions from 'actions/InCall/InCallVideo';
import { VIDEO_PRIMARY, VIDEO_FOOTER_PIP, VIDEO_PRESENTATION_PIP } from 'constants/InCall/InCallVideo';
import { isCallConnected } from 'utils/call-utils';
import {
  setPillNotificationWithTimeout,
  deletePillNotification,
} from 'actions/Notification';
import { tooltipNotifications } from 'constants/Notification';
import { PIP_EXPANDED_SETTING } from 'constants/UserSettings';
import {
  callActions,
  callSelectors,
  conferenceParticipantsSelectors,
  conferenceSelectors,
  currentUserSelectors,
  streamActions,
  usersActions,
  userProfileSelectors,
  featureSelectors
} from '@lifesize/nucleus';
import _get from 'lodash/get';
import _find from 'lodash/find';
import { FLAG_RAISE_HAND } from 'constants/FeatureFlags';


/**
 * This container will have management for call controls.
 * Mute, Hangup, local pip display, etc...
 */

const mapActionCreators = dispatch => ({
  togglePip: () => {
    dispatch(actions.togglePipExpanded());
  },
  onRaiseHand: (isRaised) => {
    if (!!isRaised) {
      dispatch(usersActions.lowerOwnHand());
    } else {
      dispatch(usersActions.raiseHand());
    }
  },
  onVideoMuteClick: () => dispatch(streamActions.toggleVideoMute()),
  onStartRecording: () => dispatch(callActions.startRecording()),
  onStopRecording: () => dispatch(callActions.stopRecording()),
  onKebabClicked: () => dispatch(actions.toggleKebabExpanded()),
  onDTMFClicked: number => dispatch(callActions.sendDtmf(number)),
  toggleDialPad: () => {
    dispatch(actions.toggleDialPad());
  },
  addNotification: message => dispatch(setPillNotificationWithTimeout(message)),
  deleteNotification: () => dispatch(deletePillNotification())
});

const mapStateToProps = (state) => {
  const activeCall = callSelectors.activeCallSelector(state);
  const isConnected = isCallConnected(activeCall);
  const recorder = _get(activeCall, 'recorder');
  const presenter = _find(activeCall.participants, p => (p.isPresenting));
  const videoLayout = _get(state, 'app.inCallVideo.videoLayout');
  const videoWidth = _get(videoLayout, ['videos', VIDEO_PRIMARY, 'width']) || _get(videoLayout, 'container.width');
  const handIsProcessing = !!conferenceSelectors.selectIsProcessingHandCommand(state);
  const handIsRaised = !!conferenceParticipantsSelectors.selectIsCurrentUserHandRaised(state);
  const btnNotificationRaisedHand = _get(state, `app.notification.tooltips.${tooltipNotifications.inCallActionBtnRaiseHand}`) || undefined;
  const showRaiseHandsButton = !!featureSelectors.getFeatureFlag(state)(FLAG_RAISE_HAND);

  return ({
    activeCall,
    btnNotificationRaisedHand,
    canRaiseHand: !!conferenceSelectors.selectConferenceId(state), // the call state needs to be active in order to send the necessary commands
    canStopRecording: _get(activeCall, 'canStopRecording'),
    handIsProcessing,
    handIsRaised,
    isConnected,
    isGuest: userProfileSelectors.selectIsGuest(state),
    isMinimized: _get(state, 'app.inCallVideo.isMinimized'),
    isRecording: _get(activeCall, 'isRecording'),
    kebabExpanded: state.app.inCallVideo.kebabExpanded,
    pipExpanded: _get(currentUserSelectors.myInfo(state), ['userSettings', PIP_EXPANDED_SETTING]),
    recorder,
    selfPresenting: _get(presenter, 'isSelf', false),
    showCameraControls: _get(state, 'app.inCallVideo.showCameraControls'),
    showDialPad: _get(state, 'app.inCallVideo.showDialPad'),
    videoElementId: VIDEO_FOOTER_PIP,
    videoLayout,
    videoPresentationId: VIDEO_PRESENTATION_PIP,
    videoWidth,
    wasKicked: _get(activeCall, 'wasKicked'),
    showRaiseHandsButton
  });
};

export default injectIntl(connect(mapStateToProps, mapActionCreators)(Footer));
